import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import localeDECH from '@angular/common/locales/de-CH';
import { registerLocaleData } from '@angular/common';
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { ContainerComponent } from './container/container.component';
import { FooterComponent } from './footer/footer.component';
import { MainMenuComponent } from './header/main-menu/main-menu.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { JqueryHelperService } from './jquery-helper.service';
import { DesktopMenuComponent } from './header/main-menu/desktop-menu/desktop-menu.component';
import { ProductDetailsComponent } from './container/product-details/product-details.component';
import { AppRoutingModule } from './app-routing.module';
import { ProductImagesComponent } from './container/product-details/product-images/product-images.component';
import { ProductDescriptionComponent } from './container/product-details/product-description/product-description.component';
import { ProductsAndFilterComponent } from './container/products-and-filter/products-and-filter.component';
import { ProductfilterComponent } from './container/products-and-filter/productfilter/productfilter.component';
import { ProductListGridComponent } from './container/products-and-filter/product-list-grid/product-list-grid.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ProductEffects } from './effects/product.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ProductService } from './shared/product.service';
import { metaReducers, reducers } from './reducers/reducer.factory';
import { FilterService } from './shared/filter.service';
import { SearchComponent } from './header/search/search.component';
import { FormsModule } from '@angular/forms';
import { ImageZoomModule } from 'angular2-image-zoom';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ANIMATION_TYPES, LoadingModule } from 'ngx-loading';
import { AdDirective } from './container/adds/ad.directive';
import { SalesInfoAddComponent } from './container/adds/sales-info-adds-component';
import { AdBannerComponent } from './container/adds/ad-banner.component';
import { AdService } from './container/adds/ad.service';
import { AdEffects } from './container/adds/store/ad.effects';
import { ProductWindowComponent } from './product-window/product-window.component';
import { ProductComponent } from './container/product/product.component';
import { WindowDetailsComponent } from './product-window/window-details/window-details.component';
import { WindowEffects } from './effects/window.effects';
import { MobileMenuComponent } from './mobile-menu/mobile-menu.component';
import { CategoriesEffect } from './effects/categories.effects';
import { LocationService } from "./shared/geolocation.service";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { IonRangeSliderModule } from "ng2-ion-range-slider";
import { AgmCoreModule } from '@agm/core';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgcCookieConsentModule, NgcCookieConsentConfig } from 'ngx-cookieconsent';
import { CookieService } from './shared/cookie.service';
import { ImagePreloader } from './shared/preload.directive';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

registerLocaleData(localeDECH);

const cookieConfig: NgcCookieConsentConfig = {
  "cookie": {
    "domain": "test.sales-info.ch"
  },
  "position": "bottom",
  "theme": "classic",
  "palette": {
    "popup": {
      "background": "#000000BF",
      "text": "#ffffff",
      "link": "#ffffff"
    },
    "button": {
      "background": "#ffffff",
      "text": "#000000",
      "border": "transparent"
    }
  },
  "type": "info",
  "content": {
    "message": "This website uses cookies to ensure you get the best experience on our website.",
    "dismiss": "Got it!",
    "deny": "Refuse cookies",
    "link": "Learn more",
    "href": "https://cookiesandyou.com"
  },
  // "cookie": {
  //   "header": "Cookies used on the website!",
  //   "message": "This website uses cookies to ensure you get the best experience on our website.",
  //   "dismiss": "Got it!",
  //   "allow": "Allow cookies",
  //   "deny": "Decline",
  //   "link": "Learn more"
  // }
}



@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    ContainerComponent,
    FooterComponent,
    MainMenuComponent,
    MobileMenuComponent,
    DesktopMenuComponent,
    ProductDetailsComponent,
    ProductImagesComponent,
    ProductDescriptionComponent,
    ProductsAndFilterComponent,
    ProductfilterComponent,
    ProductListGridComponent,
    SearchComponent,
    AdBannerComponent,
    SalesInfoAddComponent,
    AdDirective,
    ProductWindowComponent,
    ProductComponent,
    WindowDetailsComponent,
    ImagePreloader
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    ImageZoomModule,
    PaginationModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyDz8nJxkV3UgtDjRGGJuECkiZM3LCIm870",
      libraries: ["places"]
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([
      ProductEffects, AdEffects, WindowEffects, CategoriesEffect
    ]),
    StoreDevtoolsModule.instrument(),
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.wanderingCubes,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '4px',
      primaryColour: '#ffffff',
      secondaryColour: '#ffffff',
      tertiaryColour: '#ffffff'
    }),
    TooltipModule.forRoot(),
    IonRangeSliderModule,
    NgcCookieConsentModule.forRoot(cookieConfig)

  ],
  entryComponents: [SalesInfoAddComponent],
  providers: [AdService, ProductService, FilterService, JqueryHelperService, LocationService, CookieService,
    { provide: LOCALE_ID, useValue: "de-CH" }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/app.module.ts